import { combineReducers } from 'redux';

import { HYDRATE } from 'next-redux-wrapper';
import auth from './auth';
import backgroundImage from './backgroundImage';
import payment from './payment';
import referral from './referral';
import campaigns from './campaigns';
import experiments from './experiments';

const rootReducer = combineReducers({
  auth,
  backgroundImage,
  payment,
  referral,
  campaigns,
  experiments,
});
const reducer = (state, action) => {
  if (action.type === HYDRATE) {
    const nextState = {
      ...state, // use previous state
      ...action.payload, // apply delta from hydration
    };
    if (state.auth.user && !nextState.auth.user) {
      nextState.auth = state.auth;
    }
    if (state.experiments.all && !nextState.experiments.all) {
      nextState.experiments = state.experiments;
    }
    if (state.backgroundImage.url && !nextState.backgroundImage.url) {
      nextState.backgroundImage = state.backgroundImage;
    }
    if (state.referral.referrer && !nextState.referral.referrer) {
      nextState.referral = state.referral;
    }
    if (
      (state.campaigns.giftCampaign && !nextState.campaigns.giftCampaign) ||
      (state.campaigns.pricingCampaign && !nextState.campaigns.pricingCampaign)
    ) {
      nextState.campaigns = state.campaigns;
    }
    return nextState;
  }
  return rootReducer(state, action);
};

export default reducer;
